const KLARNA_ORDER_ITEM_TYPE = {
    SALES_TAX: 'sales_tax',
    DISCOUNT: 'discount',
};

export default KLARNA_ORDER_ITEM_TYPE;
